import routerOptions0 from "/usr/src/app/content/n3-redirections-legacy-af53cb62-ac8f-4f63-abef-2acc08fd29ac/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}